import { Logo, WaIcon } from "./Logo";
import { Reveal } from "./Reveal";
import { waOpen, DEFAULT_MSG, WHATSAPP_DISPLAY, WHATSAPP_NUMBER, scrollToId } from "../lib/site";
import { MapPin, Instagram } from "lucide-react";
import { useContent } from "../lib/content";

const LINKS = [
    { id: "beneficios", label: "Benefícios" },
    { id: "como-funciona", label: "Como funciona" },
    { id: "sindicos", label: "Para síndicos" },
    { id: "corporativo", label: "Para empresas" },
    { id: "quem-somos", label: "Quem somos" },
    { id: "novidades", label: "Novidades" },
    { id: "galeria", label: "Galeria" },
    { id: "faq", label: "FAQ" },
    { id: "solicitacao", label: "Solicitar implantação" },
];

export default function Footer() {
    const content = useContent();
    const t = content.footer;
    return (
        <footer className="bg-[#1A231E] text-[#F7F4EC] pt-16 pb-8">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal>
                    <div className="rounded-[2rem] bg-[#0E6B3F] border-2 border-[#F7F4EC]/10 px-7 py-10 sm:px-12 sm:py-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
                        <div>
                            <h3 className="text-3xl sm:text-4xl font-extrabold leading-tight max-w-lg">
                                {t.cta_title}
                            </h3>
                            <span className="font-caveat text-3xl text-[#F1C75B] inline-block mt-2 -rotate-1">
                                {t.cta_slogan}
                            </span>
                        </div>
                        <button
                            data-testid="footer-whatsapp-quick"
                            onClick={() => waOpen(DEFAULT_MSG)}
                            className="shrink-0 inline-flex items-center gap-3 rounded-full bg-[#F57A3A] hover:bg-[#E06324] text-[#F7F4EC] font-extrabold px-8 py-4.5 py-4 text-lg transition-all duration-200 hover:-translate-y-1 cta-pulse"
                        >
                            <WaIcon className="w-6 h-6" />
                            Chamar no WhatsApp
                        </button>
                    </div>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-10">
                    <div data-testid="footer-logo">
                        <Logo light />
                        <p className="mt-4 text-sm text-[#F7F4EC]/60 leading-relaxed max-w-xs">
                            Minimercado autônomo 24h em formato contêiner ou montado em espaços
                            cedidos dentro de condomínios e empresas.
                        </p>
                    </div>
                    <nav>
                        <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-[#F1C75B]">
                            Navegação
                        </h4>
                        <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
                            {LINKS.map((l) => (
                                <li key={l.id}>
                                    <button
                                        onClick={() => scrollToId(l.id)}
                                        className="text-sm font-semibold text-[#F7F4EC]/70 hover:text-[#F1C75B] transition-colors"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                    <div data-testid="footer-contacts">
                        <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-[#F1C75B]">
                            Contato
                        </h4>
                        <a
                            href={`https://wa.me/${WHATSAPP_NUMBER}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-4 inline-flex items-center gap-2.5 text-base font-extrabold text-[#F7F4EC] hover:text-[#F1C75B] transition-colors"
                        >
                            <WaIcon className="w-5 h-5 text-[#25D366]" />
                            {content.whatsapp.display}
                        </a>
                        <a
                            href={`https://instagram.com/${(t.instagram || "").replace("@", "")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram-link"
                            className="mt-2.5 flex items-center gap-2.5 text-base font-extrabold text-[#F7F4EC] hover:text-[#F1C75B] transition-colors"
                        >
                            <Instagram className="w-5 h-5 text-[#F57A3A]" />
                            {t.instagram}
                        </a>
                        <p className="mt-3 inline-flex items-start gap-2 text-sm text-[#F7F4EC]/60 leading-relaxed">
                            <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                            {t.atendimento}
                        </p>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-[#F7F4EC]/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#F7F4EC]/45 font-semibold">
                    <span>© {new Date().getFullYear()} Conbox — Minimercado Autônomo 24h</span>
                    <a
                        href="/admin"
                        data-testid="footer-admin-link"
                        className="hover:text-[#F1C75B] transition-colors underline-offset-4 hover:underline"
                    >
                        Acesso do administrador
                    </a>
                    <span className="font-caveat text-xl text-[#F7F4EC]/60 normal-case tracking-normal">
                        aberto agora, como sempre.
                    </span>
                </div>
            </div>
        </footer>
    );
}
